// Import surface wipe images
import neosanLabsClosed from '../../assets/Neosan-labs-closed.webp';
import lws80SoftpackLysol from '../../assets/LWS80_SOFTPACK-LYSOL.webp';
import ip300Swovo160ct from '../../assets/IP-300-SWOVO-160ct.webp';
import ip330WdP72CleGreen3 from '../../assets/IP-330-WD-P72-CLE-GREEN3.webp';

export const surfaceWipesProducts = [
    {
        image: neosanLabsClosed,
        alt: 'Neosan Wipes in Bulk'
    },
    {
        image: lws80SoftpackLysol,
        alt: 'Lysol Surface Wipes'
    },
    {
        image: ip300Swovo160ct,
        alt: 'SWOVO Disinfecting Wipes'
    },
    {
        image: ip330WdP72CleGreen3,
        alt: 'Surface Wipes'
    }
]; 